module.exports = __webpack_public_path__ + "img/email-icon.2c81d155.svg";